module.exports = __webpack_public_path__ + "img/MARIY.a3c7d0fb.png";